import SelectorEngine from '../../utils/dom/selector-engine';
import EventHandler from '../../utils/dom/event-handler';
import FormComponent from '../FormComponent';
import SearchInputField from '../SearchInputField';
import TournamentDetailsSearch from '../TournamentDetailsSearch';
import { InputTypes } from '../../utils/validateFormElement';
import { Events } from '../../utils/dom/html-events';
import { ClassNames } from '../../utils/dom/css-classes';

class TournamentFinder extends FormComponent {
	constructor(element, config) {
		super(element, config);
		this.tournamentCode = undefined;
	}
	markup(value, rowData, titleMarkup) {
		this.tournamentCode = window.location.search.split('=')[1];
		return `<div class="lta-tournament-finder u-mb-5">
					  <div class="lta-tournament-finder-title ${ClassNames.Hidden}">${titleMarkup}</div>
					  <div class="lta-tournament-finder--search-input-wrapper">
						  <div class="lta-tournament-finder--search-input u-mb-2"></div>
						  <div class="lta-tournament-finder--search-form-button-wrapper u-flex">
							  <button type="button" class="lta-tournament-finder--search-form-button lta-btn lta-btn--lg lta-btn--link">Can’t find your tournament? Enter manually</button>
						  </div>
					  </div>
					  <div class="lta-tournament-finder--search-result ${ClassNames.Hidden}"></div>
					  <div class="lta-tournament-finder--search-form ${ClassNames.Hidden}">
						  <div class="lta-tournament-finder--search-form-wrapper"></div>
						  <div class="lta-tournament-finder--search-form-button-wrapper u-flex">
							  <button type="button" class="lta-tournament-finder--Details-form-button lta-btn lta-btn--lg lta-btn--link">Use tournament look-up search</button>
						  </div>
					  </div>
			</div>
		  `;
	}
	afterRender() {
		this.tournamentFinderElement = SelectorEngine.findOne('.lta-tournament-finder', this.containerEl);
		this.tournamentFinderTitle = SelectorEngine.findOne('.lta-tournament-finder-title', this.tournamentFinderElement);
		this.tournamentFinderSearchInputWrapper = SelectorEngine.findOne(
			'.lta-tournament-finder--search-input-wrapper',
			this.tournamentFinderElement
		);
		this.tournamentFinderSearchInput = SelectorEngine.findOne(
			'.lta-tournament-finder--search-input',
			this.tournamentFinderSearchInputWrapper
		);
		this.tournamentFinderSearchFormButton = SelectorEngine.findOne(
			'.lta-tournament-finder--search-form-button',
			this.tournamentFinderSearchInputWrapper
		);
		this.tournamentFinderSearchResult = SelectorEngine.findOne(
			'.lta-tournament-finder--search-result',
			this.tournamentFinderElement
		);
		this.tournamentFinderSearchForm = SelectorEngine.findOne(
			'.lta-tournament-finder--search-form',
			this.tournamentFinderElement
		);
		this.tournamentFinderSearchFormWrapper = SelectorEngine.findOne(
			'.lta-tournament-finder--search-form-wrapper',
			this.tournamentFinderSearchForm
		);
		this.tournamentFinderDetailsButton = SelectorEngine.findOne(
			'.lta-tournament-finder--Details-form-button',
			this.tournamentFinderSearchForm
		);

		this.initSearchInputField();

		this.data?.data && this.loadtournamentResult(this.data.data, true);

		EventHandler.on(this.tournamentFinderSearchFormButton, Events.Click, () => {
			this.value = undefined;
			this.searchInputTextField.remove();
			this.tournamentFinderSearchInputWrapper.classList.add(ClassNames.Hidden);
			this.tournamentFinderSearchResult.classList.add(ClassNames.Hidden);
			this.tournamentFinderSearchForm.classList.remove(ClassNames.Hidden);
			this.tournamentFinderTitle.classList.remove(ClassNames.Hidden);

			this.tournamentDetailsSearch = new TournamentDetailsSearch(this.tournamentFinderSearchFormWrapper, {
				data: this.data.tournamentFormElement
			});
			this.tournamentDetailsSearch.onChange((value) => {
				this.setupValueObject(value, 'Partially Completed');
			});
		});

		EventHandler.on(this.tournamentFinderDetailsButton, Events.Click, () => {
			this.value = undefined;
			this.tournamentDetailsSearch.remove();
			this.initSearchInputField();
			this.tournamentFinderSearchInputWrapper.classList.remove(ClassNames.Hidden);
			this.tournamentFinderSearchResult.classList.add(ClassNames.Hidden);
			this.tournamentFinderSearchForm.classList.add(ClassNames.Hidden);
			this.tournamentFinderTitle.classList.add(ClassNames.Hidden);
		});
	}
	initSearchInputField() {
		this.searchInputTextField = new SearchInputField(this.tournamentFinderSearchInput, {
			data: this.data
		});
		this.searchInputTextField.dataMapping = (item) => {
			return {
				firstLineText: item.tournamentName,
				secondLineText: `${item.tournamentVenue}`,
				dataKey: this.data.dataKey,
				dataValue: item.tournamentCode
			};
		};
		this.searchInputTextField.filterDataMapping = (item, event) => {
			return item.tournamentCode === event[this.data.dataKey];
		};
		this.searchInputTextField.searchInputMappingChange();
		this.searchInputTextField.onChange((event) => {
			this.loadtournamentResult(event.value, true);
		});
		this.setupValidateObject();
		if (this.data?.value) {
			this.loadtournamentResult(this.data?.value, true);
		}
	}
	loadtournamentResult(resultDetails, isSetupValueObject) {
		if (isSetupValueObject) {
			this.setupValueObject(resultDetails, 'Complete');
		}
		if (!resultDetails?.tournamentName) {
			return;
		}
		this.tournamentFinderSearchInputWrapper.classList.add(ClassNames.Hidden);
		this.tournamentFinderSearchForm.classList.add(ClassNames.Hidden);
		this.tournamentFinderTitle.classList.remove(ClassNames.Hidden);
		this.tournamentFinderSearchResult.classList.remove(ClassNames.Hidden);
		this.tournamentFinderSearchResult.insertAdjacentHTML('beforeend', this.renderAutoSuggestResult(resultDetails));
		this.afterAutoSuggestResultRender();
	}
	setupValueObject(value, obBoardingStatus) {
		this.value = {
			...this.data,
			value: value
				? {
						...value,
						onboardingStatus: obBoardingStatus
				  }
				: undefined
		};
		if (this.value) {
			this.dependentQuestion = this.value.dependentQuestion;
		}
	}
	afterAutoSuggestResultRender() {
		const suggestionAutoSuggestResult = SelectorEngine.findOne(
			'.lta-autosuggest-input-result',
			this.tournamentFinderSearchResult
		);
		const searchAgainButton = SelectorEngine.findOne('.lta-tournament-search--again', suggestionAutoSuggestResult);

		EventHandler.on(searchAgainButton, Events.Click, () => {
			suggestionAutoSuggestResult.remove();
			this.tournamentFinderSearchInputWrapper.classList.remove(ClassNames.Hidden);
			this.tournamentFinderTitle.classList.add(ClassNames.Hidden);
			this.tournamentFinderSearchForm.classList.add(ClassNames.Hidden);
			this.tournamentFinderSearchResult.classList.add(ClassNames.Hidden);
		});
	}
	renderAutoSuggestResult(tournamentDetail) {
		return `<div class="lta-autosuggest-input-result">
					<p class="lta-text-input__label u-mb-3">We found these details for the tournament code you provided:</p>
					<div class="u-px-3 u-py-2 u-bg-background-blue u-rounded">
						<div class="lta-autosuggest-input-result_tournament-code u-flex u-align-center u-justify-space-between  u-mb-1">
							<span class="u-body2">Tournament Code:</span>
							<span class="u-h6">${tournamentDetail.tournamentCode}</span>
						</div>
						<div class="lta-autosuggest-input-result_tournament-name u-flex u-align-center u-justify-space-between u-mb-1">
							<span class="u-body2">Tournament Name:</span>
							<span class="u-h6">${tournamentDetail.tournamentName}</span>
						</div>
						<div class="lta-autosuggest-input-result_tournament-start-date u-flex u-align-center u-justify-space-between u-mb-1">
							<span class="u-body2">Start Date:</span>
							<span class="u-h6">${tournamentDetail.tournamentStartDate}</span>
						</div>
						<div class="lta-autosuggest-input-result_tournament-end-date u-flex u-align-center u-justify-space-between u-mb-1">
							<span class="u-body2">End Date:</span>
							<span class="u-h6">${tournamentDetail.tournamentEndDate}</span>
						</div>
						<div class="lta-autosuggest-input-result_tournament-grade u-flex u-align-center u-justify-space-between u-mb-1">
							<span class="u-body2">Tournament Grade:</span>
							<span class="u-h6">${tournamentDetail.tournamentGrade}</span>
						</div>
						<div class="lta-autosuggest-input-result_tournament-venue u-flex u-align-center u-justify-space-between u-mb-1">
							<span class="u-body2">Venue:</span>
							<span class="u-h6">${tournamentDetail.tournamentVenue}</span>
						</div>
						<div class="lta-autosuggest-input-result_tournament-refree-name u-flex u-align-center u-justify-space-between u-mb-1">
							<span class="u-body2">Referee name:</span>
							<span class="u-h6">${tournamentDetail.tournamentRefreeName}</span>
						</div>
						<br>
						<br>
						<button type="button" class="lta-btn lta-btn--xs lta-btn--petite lta-btn--icon lta-btn--icon-before lta-tournament-search--again">
							<svg class="lta-icon js-lta-text-input--btn-icon u-mr-0" width="1.5em" height="1.5em" fill="currentColor" alt="search" aria-hidden="true">
								<use xlink:href="/static/images/icons/lta-icons.svg#search"></use>
							</svg>Search again
						</button>
					<div>
				</div>`;
	}
	renderInstructionLabel(instructionLabel) {
		return instructionLabel ? `<span class="lta-text-input__label-instruction">${instructionLabel}</span>` : '';
	}
	setupValidateObject() {
		this.formElementData = {
			element: this.searchInputFieldContainerElement,
			formElement: this.searchInputFieldElement,
			errorMessage: this.data.errorMessage,
			inputType: InputTypes.SELECTOR_INPUT,
			hasIcon: false
		};
	}
	validate() {
		this.searchInputTextField.validate();
		if (this.tournamentDetailsSearch) {
			this.tournamentDetailsSearch.validate();
		}
	}
}
export default TournamentFinder;
